const React = require('react');
const Col = require('./col');
import utils from 'utils/utils';

module.exports = React.createClass({

  componentDidMount(){
    if (this.props.autofocus) {
      var node = this.refs.input.getDOMNode();
      node.focus();
    }
  },

  propTypes: {
    size: React.PropTypes.string,
    label: React.PropTypes.string
  },

  handleChange(ev){
    if (typeof this.props.onChange == 'function') {
      this.props.onChange(ev);
    } else if (this.props.valueLink && typeof this.props.valueLink.requestChange == 'function') {
      var newValue = ev.target.value;
      this.props.valueLink.requestChange(newValue);
    }
  },

  render(){
    var className = ((this.props.className) || 'form-control');
    var value;

    if (this.props.valueLink) {
      value = this.props.valueLink.value || '';
    } else {
      value = this.props.value || '';
    }

    var props = utils.extend({},this.props);

    delete props.valueLink;
    delete props.onChange;
    delete props.value;
    delete props.type;
    delete props.className;

    return (
      <Col size={this.props.size} className='form-group'>
        <label>{this.props.label}</label>
        <textarea ref='input' value={value} onChange={this.handleChange} {...props} className={className}></textarea>
      </Col>
    );
  }
});


/** WEBPACK FOOTER **
 ** ./src/components/form-textarea.js
 **/